import { CONDITIONS } from '../../common';
import { FILTER_CONFIGS } from '../constants/filters.constant';
import { SEGMENT_FILTER_ATTRIBUTE, SEGMENT_FILTER_TYPE } from '../constants/segments.constant';
import { Segment, SegmentFilter, SegmentFilterOption } from '../models';

export const conditionsWithInput = new Set([
  CONDITIONS.CONTAINS,
  CONDITIONS.EQUAL,
  CONDITIONS.GREATER_THAN,
  CONDITIONS.LESS_THAN,
  CONDITIONS.MINOR_THAN,
  CONDITIONS.MORE_THAN,
  CONDITIONS.NOT_EQUAL,
  CONDITIONS.WITH_PROPERTY,
  CONDITIONS.SENT,
  CONDITIONS.NOT_SENT,
  CONDITIONS.CLICKED,
  CONDITIONS.NOT_CLICKED,
]);

export const conditionsWithDate = new Set([CONDITIONS.WAS_ON, CONDITIONS.WAS_NOT_ON]);

export const conditionsWithDateRelative = new Set([
  CONDITIONS.WAS_AGO,
  CONDITIONS.WAS_NOT_AGO,
  CONDITIONS.WAS_LESS_THAN,
  CONDITIONS.WAS_NOT_LESS_THAN,
  CONDITIONS.WAS_MORE_THAN,
  CONDITIONS.WAS_NOT_MORE_THAN,
]);

const hasSomething = (val: unknown) =>
  val !== undefined && val !== null && val !== '' && (!Array.isArray(val) || val.length > 0);

export const getDefaultSegment = (): Segment => ({
  config: [],
});

export const getDefaultSegmentFilter = (): SegmentFilter => ({
  type: SEGMENT_FILTER_TYPE.UNSUPPORTED,
  id: '',
  condition: CONDITIONS.NONE,
});

export const getFilterConfig = (
  filterId: SEGMENT_FILTER_ATTRIBUTE | SEGMENT_FILTER_TYPE
): SegmentFilterOption => {
  const filters = FILTER_CONFIGS.filter((c) => c.id === filterId);
  if (filters.length > 0) {
    return filters[0];
  }
  return FILTER_CONFIGS.filter((c) => c.id === SEGMENT_FILTER_ATTRIBUTE.UNKNOWN)[0];
};

export const isValidFilter = (filter: SegmentFilter): boolean => {
  let isValid = Boolean(filter.type && filter.id && filter.condition);
  if (isValid) {
    if (filter.condition === CONDITIONS.WITH_PROPERTY) {
      isValid = Boolean(
        filter.tagCondition &&
          (!conditionsWithInput.has(filter.tagCondition) || hasSomething(filter.input || filter.multiSelect))
      );
    } else if (conditionsWithInput.has(filter.condition)) {
      isValid = hasSomething(filter.input || filter.multiSelect);
    } else if (conditionsWithDate.has(filter.condition)) {
      isValid = hasSomething(filter.dateRange);
    } else if (conditionsWithDateRelative.has(filter.condition)) {
      isValid = hasSomething(filter.dateDays);
    }
  }
  return isValid;
};
